import { Editor } from "@tiptap/react";
import { Colors } from "./colors";
import { EventType, JSONContent } from "@markit/common.types";

export const getProductDetails = (type: EventType) => {
  switch (type) {
    case EventType.POST:
      return {
        title: "Text Post",
        singular: "Post",
        icon: "ion:newspaper",
        color: Colors.PURPLE7,
      };
    case EventType.MARKIT:
    case EventType.EXTERNAL_SHOWCLIX:
    case EventType.EXTERNAL_EVENTBRITE:
      return {
        title: "Events",
        singular: "Event",
        icon: "ion:calendar",
        color: Colors.RED3,
      };
    case EventType.EXTERNAL_DATA:
    case EventType.EXTERNAL_NO_DATA:
      return {
        title: "Linked Events",
        singular: "Linked Event",
        icon: "mdi:vector-link",
        color: Colors.BLUE5,
      };
    case EventType.WEBINAR:
      return {
        title: "Webinars",
        singular: "Webinar",
        icon: "ion:laptop-outline",
        color: Colors.PURPLE8,
      };
    case EventType.VIDEO:
      return {
        title: "Videos",
        singular: "Video",
        icon: "ion:videocam",
        color: Colors.BLUE5,
      };
    case EventType.AUDIO:
      return {
        title: "Audio",
        singular: "Audio",
        icon: "mdi:keyboard-voice",
        color: Colors.BLACK,
      };
    case EventType.CUSTOM_PRODUCT:
      return {
        title: "Custom Products",
        singular: "Custom Product",
        icon: "ion:cube",
        color: Colors.GREEN2,
      };
    case EventType.PDF:
      return {
        title: "PDFs",
        singular: "PDF",
        icon: "ion:document",
        color: Colors.YELLOW2,
      };
    case EventType.GENERIC_LINK:
      return {
        title: "Forms",
        singular: "Form",
        icon: "ion:document-text",
        color: Colors.ORANGE1,
      };
    default:
      return {
        title: "",
        icon: "",
        color: "",
      };
  }
};

// Validate the body of a product (post, event, etc.)
export const validateProductBody = (editor: Editor) => {
  const postData: JSONContent = editor.getJSON();
  // Check the size of the post data (900kb buffer limit for document max size)
  const jsonString = JSON.stringify(postData);
  const sizeInBytes = new TextEncoder().encode(jsonString).length;
  if (sizeInBytes > 900000) {
    alert("Content is too large. Please reduce the size to continue.");
    return false;
  }
  return true;
};
